import Breadcrumb from './../../components/BreadCrumb';
import ServiceComponent from './../../components/ServiceComponent';
import HeadingDetailsSection from './../../sections/HeadingDetailsSection';
import { faCoins, faMagnifyingGlassChart, faUsersCog } from '@fortawesome/free-solid-svg-icons';
import image from './../../assets/pexels/merger.jpg'

function MergersServiceScreen() {
  return (
    <>
        <HeadingDetailsSection heading='Mergers & Acquisitions (M&A) Support'>
          <Breadcrumb parent="Services" screen='Mergers & Acquisitions (M&A) Support'/>
        </HeadingDetailsSection>
        <ServiceComponent
          heading="Mergers & Acquisitions (M&A) Support"
          description="Navigate the complexities of corporate transactions with PocketLPO’s M&A Support services. We provide strategic legal assistance to ensure your mergers, acquisitions, and restructurings are seamless."
          services={[
            "Drafting and reviewing transaction agreements.",
            "Due diligence and risk assessments.",
            "Strategic advice on corporate restructuring."
          ]}
          benefits={[
            { title: "Smooth Transactions", description: "Ensure compliance and minimize risks.", icon: faCoins },
            { title: "Informed Decisions", description: "Comprehensive due diligence support.", icon: faMagnifyingGlassChart },
            { title: "Experienced Team", description: "Leverage our expertise in corporate law.", icon: faUsersCog }
          ]}
          image={image}
        />
    </>
  );
}

export default MergersServiceScreen;
